import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber, injectIntl, intlShape } from 'react-intl';
import { get, map, find, isEmpty, filter, includes } from 'lodash';
import classnames from 'classnames';
import TextButton from '../../../../../elements-buttons/text-button';
import CreateAddOnButton from '../../../../../app-bookings-custom/create-add-on-button';
import AddOnsRow from '../AddOnsRow/add-ons-row';
import AddOnCard from '../../../../../app-bookings-custom/add-on-card';
import AddOnsSummary from '../../../../../app-bookings-custom/add-ons-summary';
import CollapsingTaxAndFees from '../../../../../app-bookings-custom/collapsing-tax-and-fees';
import Button from '../../../../../elements-buttons/Button';

class AddOnsRows extends Component {
  constructor (props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.openAddtlTaxFeesModal = this.openAddtlTaxFeesModal.bind(this);
    this.deleteAddOn = this.deleteAddOn.bind(this);
  }

  handleClick (e) {
    e.preventDefault();
    const {
      fields,
      isMobile,
      toggleModal,
      inventory,
      iosWebView,
      scrollToTop
    } = this.props;
    const inventoryItems = get(inventory, 'inventory');

    if (iosWebView) {
      scrollToTop();
    }

    if (isMobile) {
      // Check if inventory array is empty to open create add on modal first
      // If not empty, open modal with drop down
      if (isEmpty(inventoryItems)) {
        return toggleModal('createAddOnModal');
      }

      return toggleModal('addItemModal');
    }

    return fields.push();
  }

  openAddtlTaxFeesModal (e) {
    const { index, toggleModal } = this.props;
    e.preventDefault();

    toggleModal('addtlTaxFeesModal', index);
  }

  deleteAddOn (index) {
    const { fields } = this.props;

    fields.remove(index);
  }

  render () {
    const {
      ssoId,
      inventory,
      currency,
      fields,
      toggleModal,
      openModal,
      items,
      getInventoryItem,
      viewAddOnDetailsAction,
      editAddOnAction,
      editBookingAddOn,
      openEditBookingAddOnModal,
      handleItemChange,
      contract,
      addOnsTotal,
      addOnsTaxTotal,
      addOnsFeeTotal,
      taxesAndFees,
      taxesArray,
      feesArray,
      isMobile = false,
      hostAddOnsSummary = {},
      hasConciergeItems,
      addOnsSummaryLoading,
      masterContract
    } = this.props;

    const masterCalculations = masterContract?.calculations;
    const guestCalculations = masterCalculations?.guest;

    const inventoryItems = get(inventory, 'inventory');
    const selectedItemIds = map(items, item => {
      if (item) {
        return item._id;
      }
    });

    const filteredOptions = filter(inventoryItems, item => {
      return !includes(selectedItemIds, item._id);
    });

    const allOptions = map(items, item => {
      const itemId = get(item, 'item_id') || get(item, '_id');
      if (itemId) {
        const inventoryObj = {
          label: item.label,
          value: itemId,
          quantity: item.count,
          unit_cost: item.unit_cost,
          unit_cost_basis: item.unit_cost_basis
        };

        return inventoryObj;
      }
    });

    const formattedOptions = map(filteredOptions, item => {
      if (!get(item, 'is_concierge')) {
        const inventoryObj = {
          label: item.label,
          value: item._id,
          quantity: item.count,
          unit_cost: item.unit_cost,
          unit_cost_basis: item.unit_cost_basis
        };

        return inventoryObj;
      }

      return null;
    });

    const inventoryOptions = filter(formattedOptions, (n) => {
      return null !== n;
    });

    const contractChildren = get(contract, 'quote.children', []);
    const contractItems = filter(contractChildren, { type: 'ITEM' });
    const hostAddOnsTotal = get(hostAddOnsSummary, 'amount');

    return (
      <div className="add-ons-rows">
        <div>
          <div>
            {
              fields.map((item, index) => {
                const options = [
                  ...inventoryOptions,
                  {
                    value: null,
                    label: <CreateAddOnButton
                      index={index}
                      openModal={openModal}
                      attributes={{ 'data-testing-id': 'create-add-on-button' }}
                    />,
                    isDisabled: false
                  }
                ];

                const itemSelected = items[index];
                const itemId = get(items[index], '_id');
                const inventoryItemObject = itemId ? find(inventoryItems, { _id: itemId }) : null;
                const unitCostBasis = inventoryItemObject ? inventoryItemObject.unit_cost_basis.replace('_', ' ') : null;
                const maxQuantity = inventoryItemObject ? inventoryItemObject.quantity : null;
                const itemContract = find(contractItems, { item_id: itemId });
                const quoteObj = 'ITEM' === (contractChildren[index] || []).type ? contractChildren[index] : {};
                const isConcierge = get(inventoryItemObject, 'is_concierge');

                return (
                  <div key={item}>
                    {
                      itemSelected && !isConcierge &&
                        <AddOnCard
                          index={index}
                          item={itemSelected}
                          unitCostBasis={unitCostBasis}
                          currency={currency}
                          itemSelected={itemSelected}
                          deleteAddOn={this.deleteAddOn}
                          viewAddOnDetailsAction={viewAddOnDetailsAction}
                          editAddOnAction={editAddOnAction}
                          editBookingAddOn={editBookingAddOn}
                          getInventoryItem={getInventoryItem}
                          openEditBookingAddOnModal={openEditBookingAddOnModal}
                          hasMaxQuantity={itemSelected.count}
                          itemContract={itemContract}
                          ssoId={ssoId}
                        />
                    }
                    {
                      !isConcierge &&
                        <AddOnsRow
                          index={index}
                          inventoryItems={inventoryItems}
                          item={item}
                          items={items}
                          options={options}
                          allOptions={allOptions}
                          unitCostBasis={unitCostBasis}
                          maxQuantity={maxQuantity}
                          currency={currency}
                          viewAddOnDetailsAction={viewAddOnDetailsAction}
                          editAddOnAction={editAddOnAction}
                          getInventoryItem={getInventoryItem}
                          itemSelected={itemSelected}
                          toggleModal={toggleModal}
                          deleteAddOn={this.deleteAddOn}
                          handleItemChange={handleItemChange}
                          quote={quoteObj}
                          itemContract={itemContract}
                          ssoId={ssoId}
                          hasConciergeItems={hasConciergeItems}
                        />
                    }
                  </div>
                );
              })
            }
          </div>
        </div>

        <div className={classnames({ 'button-card': isMobile })}>
          {
            isMobile ?
              <TextButton
                classnames="margin-md-top"
                buttonText={ this.props.intl.formatMessage({ id: 'inbox.add_ons_rows.add_item', defaultMessage: 'Add Item' }) }
                onClick={this.handleClick}
                icon="+"
                attributes={
                  {
                    'data-testing-id': 'add-item-button',
                    type: 'button'
                  }
                }
              /> :
              <Button
                onClick={this.handleClick}
                attributes={{ 'data-testing-id': 'add-item-button' }}
                category="secondary"
                type="button"
              >
                <FormattedMessage
                  id='inbox.add_ons_rows.add_item_button'
                  defaultMessage='+ Add Item'
                />
              </Button>
          }
        </div>

        {
          (0 < fields.length) ?
            <div>
              <div className="d-sm-none">
                <hr />
                <AddOnsSummary
                  currency={currency}
                  addOnsTotal={addOnsTotal}
                  hostAddOnsSummary={hostAddOnsSummary}
                  addOnsTaxTotal={addOnsTaxTotal}
                  addOnsFeeTotal={addOnsFeeTotal}
                  taxesAndFees={taxesAndFees}
                  taxesArray={taxesArray}
                  feesArray={feesArray}
                  isLoading={addOnsSummaryLoading}
                />
              </div>

              <div className="d-xs-none d-sm-block">
                <hr className="margin-lg-top" />

                <CollapsingTaxAndFees
                  addOnsTaxTotal={addOnsTaxTotal}
                  addOnsFeeTotal={addOnsFeeTotal}
                  taxesArray={taxesArray}
                  feesArray={feesArray}
                  currency={currency}
                />

                {guestCalculations?.us_sales_tax_add_ons > 0 && (
                  <div className="add-on-row flex space-between table-row margin-md-top">
                    <div className="title-field flex">
                      <FormattedMessage
                        id='price-breakdown.add-on-sales-tax'
                        defaultMessage='Add-on sales tax'
                      />
                    </div>
                    <div
                      className="amount-field text-right"
                      data-testing-id='add-on-sales-tax-amount'
                    >
                      <FormattedNumber
                        value={guestCalculations.us_sales_tax_add_ons}
                        currency={currency}
                        style='currency'
                      />
                    </div>
                  </div>
                )}

                <hr />

                <div className="flex space-between">
                  <h6>
                    <FormattedMessage
                      id='inbox.add_ons_rows.addons_total'
                      defaultMessage='Add-ons total'
                    />
                  </h6>
                  <div className="add-ons-total flex space-between">
                    <h6 data-testing-id="add-ons-total">
                      {masterCalculations?.add_ons_guest_with_tax === undefined ? (
                        <FormattedNumber
                          value={hasConciergeItems ? hostAddOnsTotal || 0 : addOnsTotal}
                          currency={currency}
                          style={'currency'}
                        />
                      ) : (
                        <FormattedNumber
                          value={masterCalculations?.add_ons_guest_with_tax || 0}
                          currency={currency}
                          style={'currency'}
                        />
                      )}
                    </h6>
                    <div />
                  </div>
                </div>
              </div>
            </div>
            :
            null
        }
      </div>
    );
  }
}

AddOnsRows.propTypes = {
  fields: PropTypes.object,
  currency: PropTypes.string,
  inventory: PropTypes.object,
  toggleModal: PropTypes.func,
  items: PropTypes.array,
  openModal: PropTypes.func,
  getInventoryItem: PropTypes.func,
  isMobile: PropTypes.bool,
  editBookingAddOn: PropTypes.func,
  openEditBookingAddOnModal: PropTypes.func,
  handleItemChange: PropTypes.func,
  contract: PropTypes.object,
  viewAddOnDetailsAction: PropTypes.func,
  editAddOnAction: PropTypes.func,
  taxesAndFees: PropTypes.string,
  addOnsTotal: PropTypes.string,
  addOnsTaxTotal: PropTypes.string,
  addOnsFeeTotal: PropTypes.string,
  ssoId: PropTypes.string,
  taxesArray: PropTypes.array,
  feesArray: PropTypes.array,
  iosWebView: PropTypes.bool,
  scrollToTop: PropTypes.func,
  intl: intlShape
};

export default injectIntl(AddOnsRows);
